
import { Alert, AlertTitle, Grid } from '@mui/material'
import { SerializableError } from '../util/ErrorSerialization';

/** Component for displaying the filter input control on list pages */

interface FilterInputProps {
    error?: Error | SerializableError | undefined;
    title?: string | undefined
}

const ErrorMessage: React.FC<FilterInputProps> = (props: FilterInputProps) => {
    const { error, title = 'Unexpected Error' } = props;
    let errorMessage = error?.message;
    
    return (
        <Grid style={{zIndex: 2000}}>
            <Alert severity="error">
                <AlertTitle>{title}</AlertTitle>
                {errorMessage}
            </Alert>
        </Grid>
    )
};

export default ErrorMessage;